export function basePath(hostname: string): string {
  if (!hostname.includes("localhost")) {
    return "/portalcash/chl/corecashchile-clients";
  }
  return "/corecashchile-clients";
}

export function adminPath(hostname: string): string {
  if (!hostname.includes("localhost")) {
    return "/portalcash/chl/corecashchile-users";
  }
  return "/corecashchile-users";
}
